export const StateOptions = [
    { value: "selectState", label: "Select Province" },
    { value: "alberta", label: "Alberta" },
    { value: "british_columbia", label: "British Columbia" },
    { value: "manitoba", label: "Manitoba" },
    { value: "new_brunswick", label: "New Brunswick" },
    { value: "newfoundland_and_labrador", label: "Newfoundland and Labrador" },
    { value: "northwest_territories", label: "Northwest Territories" },
    { value: "nova_scotia", label: "Nova Scotia" },
    { value: "nunavut", label: "Nunavut" },
    { value: "ontario", label: "Ontario" },
    { value: "prince_edward_island", label: "Prince Edward Island" },
    { value: "quebec", label: "Quebec" },
    { value: "saskatchewan", label: "Saskatchewan" },
    { value: "yukon", label: "Yukon" },
  ];
  
  
  export const CountryOptions = [
    { value: "selectCountry", label: "Select Country" },
    { value: "canada", label: "Canada" },
  ];
  
  export const RoleOptions = [
    { value: "selectRole", label: "Select Role" },
    { value: "reelTeamMember", label: "Administration - REEL Team Member" },
    { value: "pharmacyHQ", label: "Administration - Pharmacy HQ" },
    { value: "pharmacist", label: "Pharmacy Manager (Pharmacist)" },
    { value: "nonPharmacist", label: "Pharmacy Manager (Non- Pharmacist)" },
    { value: "student", label: "Pharmacy Intern - Student" },
    { value: "adminNonPharmacist", label: "Administration (Non Pharmacist)" },
    { value: "adminPharmacist", label: "Administration (Pharmacist )" },
    { value: "adminManagerNonPharmacist", label: "Administration & Pharmacy Manager (Non Pharmacist)" },
    { value: "adminManagerPharmacist", label: "Administration & Pharmacy Manager (Pharmacist )" },
    { value: "staff", label: "Staff Pharmacist" },
    { value: "phmarcyAssistant", label: "Pharmacy Assistant" },
    { value: "accountFinance", label: "Accountant - Finance" },
    { value: "enggDevelopers", label: "Engineering - Developers" },
    { value: "uxEng", label: "UI/UX Engineer" },
    { value: "designer", label: "Designer" },
    { value: "projectManager", label: "Project Manager" },
  ];
  
  
  export const SubscriptionStatusOptions = [
    { value: "selectSubscriptionStatus", label: "Select Subscription Status" },
    { value: "0", label: "Active" },
    { value: "1", label: "Inactive" },
    { value: "2", label: "Pending" },
    { value: "3", label: "Not Applicable" },
  ];
  
  export const MemberStatusOptions = [
    { value: "selectSubscriptionStatus", label: "Select Member Status" },
    { value: "", label: "All" },
    { value: "0", label: "Active" },
    { value: "1", label: "Inactive" }
  ];
  
  export const StatusReasonOptions = [
    { value: "selectStatusReasonOptions", label: "Select Status Reason" },
    { value: "personalReasons", label: "Personal Reasons" },
    { value: "personalIllness", label: "Personal Illness" },
    { value: "financialReasons", label: "Financial Reasons" },
    { value: "careerDevelopment", label: "Career Development" },
    { value: "workEnvironment", label: "Work Environment" },
    { value: "workLifeBalance", label: "Work-Life Balance" },
    { value: "violatedCompanyPolicy", label: "Violated Company Policy" },
    { value: "violatedHIPPACompliancy", label: "Violated HIPPA Compliancy" },
    { value: "neglectfulDuties", label: "Neglectful Duties" },
    { value: "other", label: "Other" },
  ];
  
  
  
  export const CompanyRoles = [
    { value: "selectCompanyRole", label: "Select Company Role" },
    { value: "pharmacyLeadershipMember", label: "Pharmacy Leadership Member" },
    { value: "pharmacyOwnerManager", label: "Pharmacy Owner & Manager" },
    { value: "pharmacyClinicalManager", label: "Pharmacy Clinical Manager" },
    { value: "pharmacyOperationsManager", label: "Pharmacy Operations Manager" },
    { value: "pharmacyDirector", label: "Pharmacy Director" },
    { value: "pharmacyAssistantDirector", label: "Pharmacy Assistant Director" },
    { value: "other", label: "Other" },
  ];
  
  export const PermissionOptions = [
    { value: "Select Permission", label: "Select Permission" },
    { value: "Full Access", label: "Full Access" },
    { value: "Limited Access", label: "Limited Access" },
    { value: "No Access", label: "No Access" },
  ];
  
  export const TimezoneOptions = [
    { value: "selectTimezone", label: "Select Timezone" },
    { value: "GMT-08:00", label: "(GMT-08:00) Pacific Time (US and Canada)" },
    { value: "GMT-07:00", label: "(GMT-07:00) Mountain Time (US and Canada)" },
    { value: "GMT-06:00", label: "(GMT- 06:00) Central Time (US and Canada)" },
    { value: "GMT-05:00", label: "(GMT-05:00) Eastern Time (US and Canada)" },
    { value: "GMT-04:00", label: "(GMT-04:00) Atlantic Time (Canada)" },
    { value: "GMT-03:30", label: "(GMT-03:30) Newfoundland and Labrador (Canada)" },
  ];